import { CaptionText, H1, H2, H3, P2 } from '../../../styles/FontStyles';
import {
  GrayBoxWrapper,
  Main,
  Section2Wrapper,
  TextWrapper,
} from '../Home.styled';

import image1 from '../../../assets/images/section2Image1.png';
import image2 from '../../../assets/images/section2Image2.png';
import image3 from '../../../assets/images/section2Image3.png';

import { Div, Img } from '../../../styles/Styles';
import {
  AppleDownload,
  AppleDownloadMobile,
  FeaturesPill,
  GooglePlayDownload,
  GooglePlayDownloadMobile,
  LockIcon,
  RocketIcon,
  TicketIcon,
} from '../../../styles/svg';
import { colors } from 'styles';

export const Section2 = () => {
  return (
    <Section2Wrapper id='section3'>
      <Main>
        <H2 center mb='60' mt='30' color={colors.primary}>
          What We Offer
        </H2>
        <GrayBoxWrapper>
          <div>
            <Img src={image1} />
            <Div>
              <H3 mb='20'>A Travel Club like no other</H3>
              <P2 mb='20'>
                Be part of a movement that is reshaping the travel industry.
                Members are enjoying exclusive access to discounted attractions,
                hotels and premium travel deals. A vibrant community of global
                explorers, all traveling seamlessly, without stress at better
                rates thanks to the Travelution Exclusive travel club.
              </P2>
              <Div $flex $column $gap='12px'>
                <TextWrapper>
                  <CaptionText center>
                    You can become a club member only by invitation from another
                    club member.
                  </CaptionText>
                </TextWrapper>
              </Div>
            </Div>
          </div>
          <div>
            <Img src={image2} />
            <Div>
              <H3 mb='20'>AI-Powered travel super app</H3>
              <P2 mb='20'>
                Game-Changer in the Travel industry. An intelligent, all-in-one
                Super App and Personal Travel Assistant that seamlessly
                integrates real-time data, predictive analytics, and
                personalisation. With each update, we will continue to redefine
                smart travel, making every journey effortless and uniquely
                tailored.
              </P2>
              <Div $flex $column $gap='12px' $mb='16px'>
                <TextWrapper>
                  <CaptionText center>
                    Travelution application is available on App Store and Google
                    Play
                  </CaptionText>
                </TextWrapper>
              </Div>
              <Div $flex $center $gap='16px' $desktop>
                <a
                  href={`https://apps.apple.com/si/app/travelution/id6741913142`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <AppleDownload />
                </a>
                <a
                  href={`https://play.google.com/store/apps/details?id=ai.travelution.travelutionapp&pcampaignid=web_share`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <GooglePlayDownload />
                </a>
              </Div>

              <Div $flex $center $gap='16px' $mobile>
                <a
                  href={`https://apps.apple.com/si/app/travelution/id6741913142`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <AppleDownloadMobile />
                </a>
                <a
                  href={`https://play.google.com/store/apps/details?id=ai.travelution.travelutionapp&pcampaignid=web_share`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <GooglePlayDownloadMobile />
                </a>
              </Div>
            </Div>
          </div>
          <div>
            <Img src={image3} />
            <Div>
              <H3 mb='20'>Unique business opportunity</H3>
              <P2 mb='20'>
                Turn your passion for travel into income with Travelution! Earn
                commissions, unlock rewards, and build a global network while
                enjoying exclusive travel perks. Join us and travel, save, and
                earn—all in one place!
              </P2>
              <Div $flex $column $gap='12px'>
                <TextWrapper>
                  <CaptionText center>
                    Find out more information about business opportunity from
                    one of our distributors.
                  </CaptionText>
                </TextWrapper>
              </Div>
            </Div>
          </div>
        </GrayBoxWrapper>
      </Main>
    </Section2Wrapper>
  );
};
